import React, { FC, ComponentProps } from 'react';
import { useIntl } from 'dibs-react-intl';
import { LOCALE_DE, LOCALE_FR } from 'dibs-intl/exports/locales';

const Sold = React.lazy(() => import('dibs-icons/exports/Sold'));
const SoldDe = React.lazy(() => import('dibs-icons/exports/SoldDe'));
const SoldFr = React.lazy(() => import('dibs-icons/exports/SoldFr'));

type Props = ComponentProps<typeof Sold | typeof SoldFr | typeof SoldDe>;

export const LocalizedSoldIcon: FC<Props> = props => {
    const { locale } = useIntl();

    if (locale === LOCALE_DE) {
        return <SoldDe {...props} />;
    }

    if (locale === LOCALE_FR) {
        return <SoldFr {...props} />;
    }

    return <Sold {...props} />;
};
